import { Box, ButtonGroup, IconButton, Paper } from "@material-ui/core";
import keyBy from "lodash/keyBy";
import * as React from "react";
import { useState } from "react";
import { Datagrid, FunctionField, ListContextProvider, Pagination, useNotify } from "react-admin";
import { useAppDataProvider } from "../../dataprovider";
import { CustomDateField } from "../CustomDateField";
import { EnumField } from "../EnumField";
import CreatedByField from "../ReferenceFields/CreatedBy/CreatedByField";
import RemoveCircleOutline from "@material-ui/icons/RemoveCircleOutline";
import { RequestFileType } from "../../Enums/RequestFileType";
import { DownloadButton } from "@airborne/react-admin";

const FileGrid = props => {
  const [fileList, setFileList] = useState([] as any);
  const [page, setPage] = useState(1);
  const perPage = 5;
  const notify = useNotify();
  const provider = useAppDataProvider();

  React.useEffect(() => {
    getFileList();
    if (props?.triggeted !== null && props?.triggeted !== undefined) props?.triggeted();
  }, [props?.trigged === true, props.filter]);

  const getFileList = async () => {
    const { data } = await provider.getList(props.source, {
      pagination: { page: 1, perPage: 99999 },
      sort: { field: "Id", order: "DESC" },
      filter: props.filter,
    });
    setFileList(data);
  };

  const GetPaginationData = () => {
    return fileList.slice((page - 1) * perPage, perPage * page);
  };

  const removeButtonClick = async record => {
    await provider
      .deleteFileRelation(record.id, props.source)
      .then(result => {
        notify(`Record Deleted`, "success", false, true);
        getFileList();
        props.triggeted();
      })
      .catch(error => {
        notify(`Error : ${error}`, "error", false, true);
      })
      .finally(() => {});
  };

  return (
    <Paper elevation={4}>
      <div>
        <ListContextProvider
          value={{
            data: keyBy(GetPaginationData(), "id"),
            ids: GetPaginationData().map(({ id }) => id),
            currentSort: { field: "id", order: "DESC" },
          }}
        >
          <Datagrid {...props} optimized={true}>
            {props.canRemove && (
              <FunctionField
                render={(record: any) => (
                  <Box style={{ flex: 1, flexDirection: "row" }}>
                    <ButtonGroup variant="text" size="small">
                      <IconButton
                        onClick={e => {
                          e.stopPropagation();
                          removeButtonClick(record);
                        }}
                        color="primary"
                      >
                        <RemoveCircleOutline />
                      </IconButton>
                    </ButtonGroup>
                  </Box>
                )}
              />
            )}
            <FunctionField
              style={{ fontSize: 12 }}
              label="Name"
              render={(record: any) => (
                <DownloadButton target={`download/${record.objectKey}`} buttonText={record.name} variant="text" />
              )}
            />
            {props?.showFileType && (
              <FunctionField
                style={{ fontSize: 12 }}
                label="File Type"
                render={(record: any) =>
                  record.requestFileTypeEnum === Number(RequestFileType.Customer)
                    ? "CUSTOMER"
                    : record.requestFileTypeEnum === Number(RequestFileType.TT)
                      ? "TT"
                      : record.requestFileTypeEnum === Number(RequestFileType.AarScopeInvestigation)
                        ? "AAR SCOPE INVESTIGATIOM"
                        : record.requestFileTypeEnum === Number(RequestFileType.ShippingInvoice)
                          ? "SHIPPING INVOICE"
                          : record.requestFileTypeEnum ===
                              Number(RequestFileType.LastCertificateOrShopReportsOrPastActivityRelated)
                            ? "Last Certificate/Shop Reports/Past Activity Related"
                            : record.requestFileTypeEnum === Number(RequestFileType.UsTag)
                              ? "Us Tag "
                              : "AAR PROVIDE NECESSARY"
                }
              />
            )}
            {props?.showGroup && (
              <EnumField label={"Group Type"} enumName={"RequestFileType"} source={"requestFileTypeGroupEnum"} />
            )}
            <CustomDateField source="createdDate" label="CREATED DATE" />
            <CreatedByField label="CREATED BY" link={false} />
          </Datagrid>
          <Pagination
            //@ts-ignore
            page={page}
            perPage={perPage}
            setPage={setPage}
            total={fileList.length}
          />
        </ListContextProvider>
      </div>
    </Paper>
  );
};

export default FileGrid;
